import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import akaaniLogo from '../../design-system/Assets/green-logo.png';
const LogoutContainer = styled.div`
  height: 100vh;
  display: grid;
  place-items: center;
  align-items: center;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

function Logout() {
  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem('x-access-token');
    localStorage.removeItem('user');
    setTimeout(() => {
      history.push('/marketplace');
    }, 1000);
  }, [history]);

  return (
    <LogoutContainer>
      <div>
        <img src={akaaniLogo} alt="Akaani" />
        <p>loading....</p>
      </div>
    </LogoutContainer>
  );
}

export default Logout;
